import { Avatar, AvatarImage, Facehash } from 'facehash'

const THEME_COLORS = [
  '#ff7300', // primary orange
  '#ff8c00', // chart-1 / ring orange
  '#20c997', // chart-2 teal
  '#6f42c1', // chart-3 purple
  '#fd7e14', // chart-4 orange
  '#d63384', // chart-5 pink
  '#007bff', // dark mode chart-3 blue
]

export function FaceHash({
  user,
  className = 'w-8 h-8 rounded-full border-px text-black',
}: {
  user: { image?: string | null; name?: string | null; email: string }
  className?: string
}) {
  return (
    <Avatar className={className}>
      <AvatarImage src={user.image} />
      <Facehash
        colors={THEME_COLORS}
        name={user.name ? `${user.name} ${user.email}` : user.email}
      />
    </Avatar>
  )
}
